import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content" }

import LeftSideBar from "./components/LeftSideBar.vue";
import BuyVIPDialogues from "@/components/Dialogues/BuyVIPDialogues.vue";
import UserServiceDialogue from "@/components/Dialogues/UserServiceDialogue.vue";
import LogoutDialogues from "@/components/Dialogues/LogoutDialogues.vue";
import ChatBase from "@/components/Dialogues/Chat/ChatBase.vue";
import LoginDialogue from "@/components/Dialogues/LoginDialogue.vue";
import EditChatTitleDialogue from "@/components/Dialogues/EditChatTitleDialogue.vue";
import DeleteChatHistoryDialogue from "@/components/Dialogues/DeleteChatHistoryDialogue.vue";

import { isExpand } from "@/views/Home/useData/useHomePage";
import { ref, watch, computed } from "vue";
import { getDeviceWidth } from "@/utils/device";
import { isCompactMode } from "@/data/pubilc";
import LeftSideBarDrawer from "@/views/Home/components/LeftSideBarDrawer.vue";
import CustomPopup from "@/components/custom-popup/customPopup.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const deviceWidth = getDeviceWidth();

watch(deviceWidth, () => {
  const newWidth = deviceWidth.value;
  isCompactMode.value = newWidth <= 680;
  if (newWidth > 1000) {
    isExpand.value = true;
  } else if (newWidth <= 1000) {
    isExpand.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "page-base" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, { class: "p0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_unref(isCompactMode))
              ? (_openBlock(), _createBlock(LeftSideBar, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(ChatBase)
          ])
        ]),
        _: 1
      }),
      _createVNode(BuyVIPDialogues),
      _createVNode(UserServiceDialogue),
      _createVNode(LogoutDialogues),
      _createVNode(LoginDialogue),
      _createVNode(EditChatTitleDialogue),
      _createVNode(DeleteChatHistoryDialogue),
      (_unref(isCompactMode))
        ? (_openBlock(), _createBlock(LeftSideBarDrawer, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(CustomPopup)
    ]),
    _: 1
  }))
}
}

})